var render = function () {
  var _vm$selectedProject, _vm$selectedProject2, _vm$profile, _vm$selectedProject3, _vm$selectedProject4, _vm$selectedProject5, _vm$selectedProject6, _vm$selectedProject7, _vm$selectedProject8, _vm$selectedProject9, _vm$selectedProject10, _vm$selectedProject11, _vm$selectedProject12;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-overlay', {
    staticClass: "w-100 h-100",
    attrs: {
      "show": _vm.loading,
      "spinner-variant": "primary",
      "spinner-type": "grow"
    }
  }, [_c('div', [_c('div', {
    staticClass: "control mb-4"
  }, [_c('div', {
    staticClass: "flex-left"
  }, [_c('div', {
    staticClass: "costum-breadcrumb"
  }, [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.goBack();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('navigation.pages.customer-project')))]), _c('img', {
    staticClass: "mx-3",
    attrs: {
      "src": require("@/assets/customer-project/divider.svg")
    }
  }), _vm._v(_vm._s((_vm$selectedProject = _vm.selectedProject) === null || _vm$selectedProject === void 0 ? void 0 : _vm$selectedProject.name) + " ")]), _c('form-selector', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm$selectedProject2 = _vm.selectedProject) === null || _vm$selectedProject2 === void 0 ? void 0 : _vm$selectedProject2.id) === ((_vm$profile = _vm.profile) === null || _vm$profile === void 0 ? void 0 : _vm$profile.projectId),
      expression: "selectedProject?.id === profile?.projectId"
    }],
    staticClass: "ml-3",
    attrs: {
      "options": _vm.packages,
      "disabled": !((_vm$selectedProject3 = _vm.selectedProject) !== null && _vm$selectedProject3 !== void 0 && _vm$selectedProject3.enabled)
    },
    model: {
      value: _vm.selectedPackage,
      callback: function callback($$v) {
        _vm.selectedPackage = $$v;
      },
      expression: "selectedPackage"
    }
  })], 1), _c('div', {
    staticClass: "flex-right"
  }, [_c('invite-button', {
    attrs: {
      "id": (_vm$selectedProject4 = _vm.selectedProject) === null || _vm$selectedProject4 === void 0 ? void 0 : _vm$selectedProject4.id,
      "events": _vm.projectEvents,
      "variant": "primary",
      "text": _vm.$t('invite.title'),
      "icon": "customer-project/invite.svg",
      "disabled": !((_vm$selectedProject5 = _vm.selectedProject) !== null && _vm$selectedProject5 !== void 0 && _vm$selectedProject5.enabled)
    }
  }), ((_vm$selectedProject6 = _vm.selectedProject) === null || _vm$selectedProject6 === void 0 ? void 0 : _vm$selectedProject6.role) === 'ADMINISTRATOR' && (_vm$selectedProject7 = _vm.selectedProject) !== null && _vm$selectedProject7 !== void 0 && _vm$selectedProject7.enabled ? _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.deactivate-modal",
      modifiers: {
        "deactivate-modal": true
      }
    }],
    staticClass: "ml-3",
    attrs: {
      "variant": "danger"
    }
  }, [_c('img', {
    staticClass: "mb-1",
    attrs: {
      "src": require("@/assets/customer-project/deactivate.svg")
    }
  }), _vm._v(" " + _vm._s(_vm.$t('customer-project.deactivate')) + " ")]) : _vm._e(), ((_vm$selectedProject8 = _vm.selectedProject) === null || _vm$selectedProject8 === void 0 ? void 0 : _vm$selectedProject8.role) === 'ADMINISTRATOR' && !((_vm$selectedProject9 = _vm.selectedProject) !== null && _vm$selectedProject9 !== void 0 && _vm$selectedProject9.enabled) ? _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.reactivate-modal",
      modifiers: {
        "reactivate-modal": true
      }
    }],
    staticClass: "ml-3",
    attrs: {
      "variant": "primary"
    }
  }, [_c('img', {
    staticClass: "mb-1",
    attrs: {
      "src": require("@/assets/customer-project/reactivate.svg")
    }
  }), _vm._v(" " + _vm._s(_vm.$t('customer-project.reactivate')) + " ")]) : _vm._e()], 1), _c('confirmation-modal', {
    attrs: {
      "id": "deactivate-modal",
      "variant": "danger",
      "yes-key": "customer-project.modal.deactivate.ok"
    },
    on: {
      "on-click-yes": _vm.onClickDeactivate
    },
    scopedSlots: _vm._u([{
      key: "body-text",
      fn: function fn() {
        return [_c('img', {
          staticClass: "modal-icon",
          attrs: {
            "src": require("@/assets/customer-project/danger.svg")
          }
        }), _c('h2', {
          staticClass: "modal-title"
        }, [_vm._v(" " + _vm._s(_vm.$t('customer-project.modal.deactivate.title')) + " ")]), _c('p', {
          staticClass: "modal-p"
        }, [_vm._v(" " + _vm._s(_vm.$t('customer-project.modal.deactivate.body')) + " ")])];
      },
      proxy: true
    }])
  }), _c('confirmation-modal', {
    attrs: {
      "id": "reactivate-modal",
      "yes-key": "customer-project.modal.reactivate.ok"
    },
    on: {
      "on-click-yes": _vm.onClickReactivate
    },
    scopedSlots: _vm._u([{
      key: "body-text",
      fn: function fn() {
        return [_c('img', {
          staticClass: "modal-icon",
          attrs: {
            "src": require("@/assets/customer-project/danger.svg")
          }
        }), _c('h2', {
          staticClass: "modal-title"
        }, [_vm._v(" " + _vm._s(_vm.$t('customer-project.modal.reactivate.title')) + " ")]), _c('p', {
          staticClass: "modal-p"
        }, [_vm._v(" " + _vm._s(_vm.$t('customer-project.modal.reactivate.body')) + " ")])];
      },
      proxy: true
    }])
  })], 1), _c('project-table', {
    attrs: {
      "project-users": _vm.projectUsers,
      "project-role": (_vm$selectedProject10 = _vm.selectedProject) === null || _vm$selectedProject10 === void 0 ? void 0 : _vm$selectedProject10.role,
      "project-id": (_vm$selectedProject11 = _vm.selectedProject) === null || _vm$selectedProject11 === void 0 ? void 0 : _vm$selectedProject11.id,
      "profile": _vm.profile,
      "disabled": !((_vm$selectedProject12 = _vm.selectedProject) !== null && _vm$selectedProject12 !== void 0 && _vm$selectedProject12.enabled),
      "options": _vm.projectEvents,
      "events": _vm.events
    },
    on: {
      "change": _vm.onChange,
      "remove": _vm.onRemove,
      "on-select-event": _vm.onSelectEvent,
      "on-remove-event": _vm.onRemoveEvent
    }
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }